import { RateProvider } from "./outbound-labels";

export const DHL_VOID_MAX_AGE_DAYS = 45;

/** TikTok labels can never be voided. */
export function canVoidProviderLabel(provider: RateProvider): boolean {
  return provider !== RateProvider.TIKTOK;
}

/** DHL eCommerce blocks voiding international and >45-day-old labels. */
export function canVoidDhlByCountriesAndAge({
  originCountry,
  destinationCountry,
  createdAt,
  now = new Date(),
}: {
  originCountry: string | null | undefined;
  destinationCountry: string | null | undefined;
  createdAt: Date | null | undefined;
  now?: Date;
}): boolean {
  if (!originCountry || !destinationCountry) {
    return false;
  }
  if (originCountry !== destinationCountry) {
    return false;
  }
  if (!createdAt) {
    return false;
  }
  const maxAgeMs = DHL_VOID_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  return now.getTime() - createdAt.getTime() <= maxAgeMs;
}
